/* eslint ember/avoid-leaking-state-in-ember-objects: "off" */
import { JSONAPISerializer } from 'miragejs'

export default JSONAPISerializer.extend({
  alwaysIncludeLinkageData: true,
  include: ['synchronisation'],
})
